import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Switch, Select, Form, Input, message } from 'antd';
// import getUser from '../hooks/getUser';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { app } from '../../config';
import getUser from '../../hooks/getUser';
import useFetchRoles from '../../hooks/fetchRoles';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const Orguseredit = () => {
  const {t}=useTranslation(["common"])
  const [uploadObj, setUploadObj] = useState({});
  const navigate = useNavigate();
  let userId = JSON.parse(localStorage.getItem('userId'));
  let user=JSON.parse(localStorage.getItem('user'));
  console.log(user);
  let res = getUser(userId);
  let userObj=res.response?res.response.data:null;
  console.log(userObj);
  const r = useFetchRoles();
  const token = getTokenfromUserObj();
  console.log(r);
  const roles=r.response?r.response.data:[];
  console.log(roles);
  const o = useFetchOrganizations();
  const orgs = o.response ? o.response.data : [];
  console.log(orgs);
  const uploadData=async(uploadObj)=>{
    console.log("Function Running", uploadObj)
    // return
    try {
      const res = await axios.post(`${app.URL}/user/updateuser/${userObj.userId}`, uploadObj, { headers: { auth: token } });
          console.log("🚀 ~ file: EditOrg.js:49 ~ uploadData ~ res", res)
      if (res.status === 200) {
        const storedData = localStorage.getItem('user');

        if (storedData) {
          const dataObject = JSON.parse(storedData);
          dataObject.name = uploadObj.name; // Change 'specificKey' to your actual key

          localStorage.setItem('user', JSON.stringify(dataObject));
          // navigate('/organization/dashboard');
          // window.location.reload();
        }
        navigate('/organization/dashboard');
        message.success("Profile Updated Successfully.");
      }
      
        // window.alert(res.data)
              // if (res.data) navigate('/orglist');
            } catch (err) {
              console.log(err);
              // if (err) console.log(err.response.data.message);
              // else retrun;
            }


  }

  const onFinish = (values) => {
    console.log('Success:', values);
    // return
    let payload={
      name:values.name?values.name:userObj.name,
      // email:values.email?values.email:userObj.email,
      Password:values.password?values.password:null,
      phone:values.phone?values.phone:userObj.phone,
      roleId:values.roleId?values.roleId:userObj.roleId,
      organizationId:values.organizationId?values.organizationId:userObj.organizationId,
      // isActive: values.isActive === true ? 1 : 0,
      isActive:  1 ,

      updatedByUserId:user.userId
    };
    setUploadObj(payload)
  };
  console.log(payload);
  if (Object.keys(payload).length > 0) uploadData(payload);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  // console.log(res.response.data);

//   let checked = false;
  
//   const handleChange = (e) => {

//     const value = e.target.value;
//     setFormFields({ ...formfields, [e.target.name]: value });
//   };
//   console.log(orgObj);
// const handleCheckChange=(e)=>{
//     console.log(e.target.checked);
//     let setChecked='1';
//     if(!e.target.checked)setChecked = '0';
//     setFormFields({...formfields, is_active:setChecked});
// }
//   const handleSubmit = async () => {
//     console.log(formfields);
//     const temp = { ...formfields };
//     console.log('🚀 ~ file: AddOrganization.jsx:26 ~ handleSubmit ~ temp', temp);
//     let Objkeys = Object.keys(temp);
//     console.log('🚀 ~ file: EditOrg.js:25 ~ handleSubmit ~ Objkeys', Objkeys);
//     Objkeys.forEach((element) => {
//       if (temp[element]===0) temp[element] = temp[element];
//       else if (!temp[element]) temp[element] = orgObj[element];
//     });
//     console.log(temp);
//       try {
//     const res = await axios.post(`http://127.0.0.1:3001/org/updateorg/${orgObj.organization_id}`,temp);
//         console.log('🚀 ~ file: AddOrganization.jsx:34 ~ handleSubmit ~ res', res);
//         console.log('Data response' + res.data);
//         window.alert(res.data)
//         if (res.data) navigate('/orglist');
//       } catch (err) {
//         console.log(err);
//         if (err) console.log(err.response.data.message);
//         else retrun;
//       }
//   };

  return (
    <div class="col-lg-9 mt-4 ">
    <div class='card'>
      <div class='card-body p-5'> 
      <div className='col-lg-6 offset-lg-4'>
      <h2 class='mb-5 fw-bold fs-3'>{t("Update Profile")}</h2>

      </div>
  
        <div class='col-lg-10 '>
{res.response?   <Form
      name='basic'
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 25,
      }}
      style={{
        maxWidth: 600,
      }}
      initialValues={{
        remember: true,
        ['name']: userObj.name,
        ['email']: userObj.email,
        ['phone']: userObj.phone,
        ['roleId']: userObj.roleId,
        ['organizationId']: userObj.organizationId,
        ['isActive']:  userObj.isActive===1?true:false,
        
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete='off'
    >
                              <Form.Item
                             colon={false}
        label='Organization'
        name='organizationId'
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          style={{
            width: 160,
          }}
        
          placeholder="Select"
          disabled={true}
        >
          {orgs?orgs.map((org) => {
            return (
              <Option  key={org.organizationId} value={org.organizationId}>
                {org.organizationName}
              </Option>
            );
          }): " "}
        </Select>
      </Form.Item>
      <Form.Item
           colon={false}
        label='Name'
        name='name'
        defaultValue='1'
        rules={[
          {
            required: true,
            message: 'Please input your name!',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
           colon={false}
        label='Email'
        name='email'
        rules={[
          {
            required: true,
            type:'email',
            message: 'Please input your email!',
          },
        ]}
      >
        <Input disabled={true} />
      </Form.Item>
      <Form.Item
           colon={false}
        label='Password'
        name='password'
        rules={[
          {
            required: false,
            message: 'Please input Password!',
          },
        ]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
           colon={false}
        label='Phone'
        name='phone'
        rules={[
          {
            required: true,
            message: 'Please input Phone!',
          },
        ]}
      >
        <Input />
      </Form.Item>
      {/* <Form.Item label='Active'      colon={false} valuePropName='checked' name='isActive'>
        <Switch />
      </Form.Item> */}
      {/* Select box for Role */}
      <Form.Item
        label='Role'
        colon={false}
        name='roleId'
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          style={{
            width: 160,
          }}
          className='select-box'
          placeholder="Select"
        >
          {roles.map((role) => {
            return (
              <Option key={role.roleId} value={role.roleId}>
                {role.name}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
      {/* Select box for Organization */}

      {/* Outlet Name */}
      {/* <Form.Item
        label='Outlet Name'
        name='outletName'
        rules={[
          {
            required: false,
            message: 'Please input your username!',
          },
        ]}
      >
        <Input />
      </Form.Item> */}
      {/* Select box for organization */}
      {/* <Form.Item
        label='Address'
        name='address'
        rules={[
          {
            required: false,
            message: 'Please input your address!',
          },
        ]}
      >
        <Input />
      </Form.Item> */}
      {/* Organization */}
      {/* <Form.Item
        label='Organization'
        name='organizationId'
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          listHeight={250}
          listItemHeight={500}
          style={{
            width: 120,
          }}
        >
          {cities.map((city) => {
            return (
              <Option key={city.cityId} value={city.cityId}>
                {city.name}
              </Option>
            );
          })}
        </Select>
      </Form.Item> */}
      {/* State */}
      {/* <Form.Item
        label='State'
        name='state'
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          listHeight={250}
          listItemHeight={500}
          style={{
            width: 120,
          }}
        >
          {states.map((state) => {
            return (
              <Option key={state.stateId} value={state.stateId}>
                {state.name}
              </Option>
            );
          })}
        </Select>
      </Form.Item> */}
      {/* Country */}
      {/* <Form.Item
        label='Country'
        name='country'
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          listHeight={250}
          listItemHeight={500}
          style={{
            width: 120,
          }}
        >
           {countries.map((country) => {
            return (
              <Option key={country.countryId} value={country.countryId}>
                {country.name}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
      <Form.Item
        label='Longitude'
        name='longitude'
        rules={[
          {
            required: false,
            message: 'Please input your address!',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label='Latitude'
        name='latitude'
        rules={[
          {
            required: false,
            message: 'Please input your address!',
          },
        ]}
      >
        <Input />
      </Form.Item> */}
 
      {/* <Form.Item
        label='Description'
        name='description'
        rules={[
          {
            message: 'Please input your password!',
          },
        ]}
      >
        <TextArea rows={4} />
      </Form.Item> */}

      <Form.Item
      
        wrapperCol={{
          offset: 8,
          span: 16,
        }}
      >
        <button type='primary' class='btn btn-primary button' htmlType='submit'>
         Save
        </button>
      </Form.Item>
    </Form>: " " }
  </div>
{/* 
        <form>
          <div class='form-outline mb-4'>
            <label class='form-label' for='form3Example1cg'>
              {t("Id")}
            </label>
            <input type='text' name='id' disabled defaultValue={orgObj ? orgObj.organizationId : ' '} id='form3Example1cg' class='form-control form-control-lg' />
          </div>
          <div class='form-outline mb-4'>
            <label class='form-label' for='form3Example1cg'>
              {t("Name")}
            </label>
            <input type='text' name='organization_name' id='form3Example1cg' defaultValue={orgObj ? orgObj.organizationName : ' '} class='form-control form-control-lg' onChange={handleChange} />
          </div>

          <div class='form-outline mb-4'>
            <label class='form-label' for='form3Example3cg'>
              {t("Email")}
            </label>
            <input type='email' name='email' id='form3Example3cg' defaultValue={orgObj ? orgObj.email : ' '} class='form-control form-control-lg' onChange={handleChange} />
          </div>

          <div class='form-outline mb-4'>
            <label class='form-label' for='form3Example3cg'>
              {t("Description")}
            </label>
            <input type='test' name='description' id='form3Example3cg' class='form-control form-control-lg' defaultValue={orgObj ? orgObj.description : ' '} onChange={handleChange} />
          </div>
          <div class='form-check'>
            <input class='form-check-input' name='is_active' type='checkbox' defaultChecked={checked}  id='flexCheckDefault' onChange={handleCheckChange} />
            <label class='form-check-label' for='flexCheckDefault'>
       {t("Active")}
            </label>
          </div>
          <div class='d-flex justify-content-center'>
            <button type='button' class='btn btn-outline-primary btn-block btn-lg gradient-custom-2 text-body' onClick={handleSubmit}>
              {t("Edit")}
            </button>
          </div>
        </form> */}
      </div> 
    </div>
 {/*   </div>
</div>
</div> */}
{/* </div> */}
{/* </section> */}
</div>

    
      /* <section class='vh-100 bg-image mt-5' style={{}}>
        <div class='mask d-flex align-items-center h-100 gradient-custom-3'>
          <div class='container h-100'>
            <div class='row d-flex justify-content-center align-items-center h-100'>
              <div class='col-12 col-md-9 col-lg-7 col-xl-6'>
                <div class='card'>
                  <div class='card-body p-5'>
                    <h2 class='text-uppercase text-center mb-5 fw-bold fs-5'>{t("Edit Organization")}</h2>

                    <form>
                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example1cg'>
                          {t("Id")}
                        </label>
                        <input type='text' name='id' disabled defaultValue={orgObj ? orgObj.organization_id : ' '} id='form3Example1cg' class='form-control form-control-lg' />
                      </div>
                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example1cg'>
                          {t("Name")}
                        </label>
                        <input type='text' name='organization_name' id='form3Example1cg' defaultValue={orgObj ? orgObj.organization_name : ' '} class='form-control form-control-lg' onChange={handleChange} />
                      </div>

                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example3cg'>
                          {t("Email")}
                        </label>
                        <input type='email' name='email' id='form3Example3cg' defaultValue={orgObj ? orgObj.email : ' '} class='form-control form-control-lg' onChange={handleChange} />
                      </div>

                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example3cg'>
                          {t("Description")}
                        </label>
                        <input type='test' name='description' id='form3Example3cg' class='form-control form-control-lg' defaultValue={orgObj ? orgObj.description : ' '} onChange={handleChange} />
                      </div>
                      <div class='form-check'>
                        <input class='form-check-input' name='is_active' type='checkbox' defaultChecked={checked}  id='flexCheckDefault' onChange={handleCheckChange} />
                        <label class='form-check-label' for='flexCheckDefault'>
                   {t("Active")}
                        </label>
                      </div>
                      <div class='d-flex justify-content-center'>
                        <button type='button' class='btn btn-outline-primary btn-block btn-lg gradient-custom-2 text-body' onClick={handleSubmit}>
                          {t("Edit")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */

  );
};

export default Orguseredit;
